window.openCalendar = function(handle) {
    if (!window.SesamiProductsMap) {
      console.error("Sesami: El mapa de productos no ha sido cargado.");
      return;
    }

    if(window.closeModalServices)
    {
      closeModalServices();
    }

    const productData = window.SesamiProductsMap[handle];

    if (!productData) {
      console.error(`Sesami: No se encontró ningún servicio con el handle "${handle}"`);
      return;
    }

    const { id: serviceId, variantId } = productData;

    // 1. Actualizamos el service-id en el web component de Sesami
    const sesamiComponent = document.getElementById('sesami-global-component');
    if (sesamiComponent) {
      sesamiComponent.setAttribute('service-id', serviceId);
    }

    // 2. Actualizamos el variant ID en el formulario nativo de Shopify
    const variantInput = document.getElementById('sesami-global-variant');
    if (variantInput) {
      variantInput.value = variantId;
    }

    // 3. Cambiamos la acción del formulario
    const globalForm = document.getElementById('sesami-global-form');
    if (globalForm) {
      globalForm.setAttribute('action', `/cart/add?id=${variantId}`);
    }

    // 4. MAGIA: Perforar el Shadow DOM para hacer clic
    // Damos 50ms para que Sesami procese el cambio de ID internamente
    setTimeout(() => {
      if (sesamiComponent) {
        // Intento A: Entramos al Shadow DOM y buscamos el botón real de Sesami
        if (sesamiComponent.shadowRoot) {
          const shadowButton = sesamiComponent.shadowRoot.querySelector('button');
          if (shadowButton) {
            shadowButton.click();
            return; // ¡Éxito! Salimos de la función
          }
        }
        
        // Intento B (Fallback): Si por alguna razón no hay Shadow DOM, 
        // buscamos cualquier botón dentro del componente y lo clicamos.
        const fallbackButton = sesamiComponent.querySelector('button') || document.getElementById('sesami-global-button');
        if (fallbackButton) {
          fallbackButton.click();
        }
      }
    }, 50);
  };


document.addEventListener('DOMContentLoaded', () => {
    window.melaunoBooking = new SesamiManager('20219592804');
});
